import { render } from "./result.vue?vue&type=template&id=7d553578&scoped=true&ts=true"
import script from "./result.vue?vue&type=script&lang=ts"
export * from "./result.vue?vue&type=script&lang=ts"

import "./result.vue?vue&type=style&index=0&id=7d553578&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d553578"]])

export default __exports__